import React from 'react'

import HARDCODE from '../../business-const/HardCode/HardCode'

import {
    GridContainerS0,
    GridItem12,
} from '../Grid/Grid'



export const CampoDisabled = ({label, value}) => {

    return (
        <GridContainerS0>
            <div
                className="ml-3 mt-0 mb-1 text-9 font-light-medium textFieldDisabled bg-white"
                 dangerouslySetInnerHTML={{ __html: label ? label : HARDCODE.htmlEspacoRegular}}
            />
            
            <GridItem12
                className='mt--2 border-radius-padrao bg-textFieldDisabled'
                style={
                    {border: '1px solid silver'}
                }
            >
                <div
                    className="ml-3 mt-4 mb-4 text-12"
                    dangerouslySetInnerHTML={{ __html: value ? value : HARDCODE.htmlEspacoRegular}}
                />
            </GridItem12>
        </GridContainerS0>
    )
}